import { memo, useCallback, useMemo } from "react";
import cn from "classnames";
import { TABLE_HEADER } from "constants/patientDetails";
import { icons } from "constants/icons";
import {
  FILTER_KEYS,
  FilterParams,
  SortConfig,
  SortDirection,
} from "types/common";
import {
  selectJointFilterParams,
  selectTypeFilterParams,
} from "store/PatientStore/selectors";
import { FilterDropdown } from "components/FilterDropdown/FilterDropdown";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { changeFilterParams } from "store/PatientStore/actions";

type Props = {
  onClick: (sortBy: string) => void;
  sortConfig: SortConfig;
};

export const VideoExamTableHeader = memo(({ onClick, sortConfig }: Props) => {
  return (
    <div className="flex px-4 mt-4">
      {TABLE_HEADER.map((item, index) => {
        const handleClick = () => {
          onClick(item.sortName);
        };
        return (
          <div
            key={item.title}
            className={cn(
              "flex space-x-1 text-[10px] text-grayDark relative",
              {
                "justify-center": index > 0,
              }
            )}
            style={{ width: item.width }}
          >
            {item.title && (
              <button
                type="button"
                className="flex space-x-2 items-center"
                onClick={handleClick}
              >
                <strong>{item.title}</strong>

                <img
                  src={icons.carrotDown}
                  alt="arrow"
                  className={cn("transition-all mt-[0.5px]", {
                    "rotate-180":
                      sortConfig.sortBy === item?.sortName &&
                      sortConfig.sortDirection === SortDirection.asc,
                  })}
                />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
});
